/**
 * Pure helper for conditional-mandatory classification dropdowns (FIX 10/11).
 *
 * A cascading classification field (Policy Type / Group / Subgroup) is:
 *  - disabled and optional while its parent is unselected;
 *  - disabled and optional (with an explanatory empty label) when the parent
 *    is selected but master data has no options for it;
 *  - enabled and REQUIRED as soon as options exist.
 *
 * Kept free of React so it is unit-testable with plain vitest (no jsdom).
 */

export interface ClassificationFieldState {
  disabled: boolean;
  required: boolean;
  placeholder: string;
}

export function classificationFieldState(
  parentSelected: boolean,
  options: unknown[] | undefined,
  emptyLabel: string, // e.g. "No policy type available"
  defaultLabel: string, // e.g. "Select policy type"
): ClassificationFieldState {
  if (!parentSelected) return { disabled: true, required: false, placeholder: defaultLabel };
  if (!options || options.length === 0) return { disabled: true, required: false, placeholder: emptyLabel };
  return { disabled: false, required: true, placeholder: defaultLabel };
}
